<template>
  <div style="background-color: white; width: 100vw; height: 100vh">
    <v-fade-transition>
      <div id="passwordLogin" v-if="passwordPrompt">
        <div id="passwordInnerLogin">
          <v-icon @click="passwordPrompt=false" class="close-icon">close</v-icon>
          <v-text-field
            label="Password"
            single-line
            @keyup.enter.native="enterCollections"
            solo
            v-model="password"
            type="password"
            style="margin-top: 1rem;"
          ></v-text-field>
          <v-btn ref="enter-button" @click="enterCollections" color="primary" dark>ENTER</v-btn>
          <v-progress-circular
            :size="50"
            :width="7"
            color="black"
            indeterminate
            v-if="isCheckingPassword"
          ></v-progress-circular>
          <p v-if="loginFailed" style="color: red; font-size: 1rem">Invalid Login</p>
        </div>
      </div>
    </v-fade-transition>
    <v-parallax v-if="greaterThanSix" dark :src="require('../assets/neck.jpg')" class="top-neck">
      <v-layout align-center column justify-center>
        <h1
          ref="title"
          offset="20"
          data-lax-preset="fadeOut"
          class="display-2 font-weight-thin mb-3 title-text"
        >Mar of Santa Barbara</h1>
        <v-btn
          ref="collections-button"
          data-lax-preset="fadeOut"
          @click="passwordPrompt=true"
          color="primary"
          dark
        >COLLECTIONS</v-btn>
      </v-layout>
    </v-parallax>
    <div class="top-neck" v-else>
      <v-layout align-center column justify-center>
        <h1
          ref="title"
          offset="20"
          data-lax-preset="fadeOut"
          class="display-2 font-weight-thin mb-3 title-text"
        >Mar of Santa Barbara</h1>
        <v-btn
          ref="collections-button"
          data-lax-preset="fadeOut"
          @click="passwordPrompt=true"
          color="primary"
          dark
        >COLLECTIONS</v-btn>
      </v-layout>
    </div>
    <v-layout id="enterHolder" column style="height: 80vh; background-color: rgb(38,36,36)">
      <div
        ref="about-holder"
        class="about-holder"
        style="width: 45%; height: 30%; background-color: white; margin-top: -5rem;z-index:9999"
      >
        <p>Mar jewelry has been designed and made in Santa Barbara, California for over thirty years. Winner of numerous design awards. Each piece is meticulously handmade in our studio. Mar jewelry can be found in fine galleries and museum shops throughout the United States."</p>
      </div>
      <div
        ref="carousel"
        id="featuredCarouselContainer"
        style="width: 45%; height: 30%; background-color: white; z-index: 999"
      >
        <p id="awardsTitle">Awards</p>
        <v-carousel dark hide-controls>
          <v-carousel-item v-for="(item,i) in $store.state.jewelry" :key="i" dark>
            <div class="carousel-item-container">
              <img class="award-image" :src="item.imageUrl" />
              <p class="award-title" style="margin-top: 1rem; font-family: DINPro Bold">{{item.title}}</p>
              <p class="award-title">{{item.awardTitle}}</p>
            </div>
          </v-carousel-item>
        </v-carousel>
      </div>
    </v-layout>
    <v-parallax dark :src="require('../assets/greg-in-studio.jpg')"></v-parallax>

    <v-footer class="pa-3 footer-greg" dark style="background-color:black; height: auto">
      <div class="greg-info-container" ref="greg-info" style="width: 100%">
        <div class="greg-about-image"></div>
        <p
          style="color: white;font-size: 0.7rem; text-align:center; margin-top: 1rem"
        >ALL MAR OF SANTA BARBARA DESIGNS COPYRIGHT GREG GEYER &copy; {{ new Date().getFullYear() }}</p>
      </div>
      <v-spacer></v-spacer>
      <div class="bottom-right-container" style="width: 100%; padding: 1rem;">
        <h1 class="display-2 font-weight-thin mb-3">Greg Geyer</h1>
        <div
          style="display: flex; flex-flow: row; justify-content: space-around; align-items:center; width: 10rem; margin: 0 auto;"
        >
          <v-btn @click="toggleShowInfo('about')" color="primary" dark>ABOUT</v-btn>
          <v-btn @click="toggleShowInfo('contact')" color="primary" dark>CONTACT</v-btn>
        </div>
        <v-expand-transition>
          <v-card-text v-show="showInfo=='about'" style="color: white; width: 100%;">
            Greg Geyer was born in Los Angeles California and has been surrounded by art his entire life. His mother, Mar Marcotte, for whom the company is named, studied at UCLA. His father, George Geyer, is an artist and retired art professor. His grandfather, Sueo Serisawa, was a painter, and his grandmother, Mary Serisawa, an avid photographer. It was art by osmosis for Greg.
            Mar has been making jewelry since the late 60s. As a child Greg would help her make ear wires and other simple items. Making jewelry was his summer job in high school and throughout college. Greg was an engineering major and studied architecture which, combined with his Japanese heritage, influence both his designs and how he constructs them.
            Greg has won multiple design awards for his jewelry. You will find Greg's designs in museum gallery gift stores and finer retailers throughout the United States.
          </v-card-text>
        </v-expand-transition>
        <v-expand-transition>
          <v-card-text v-show="showInfo=='contact'" style="text-align:center; color: white; width: 100%">
            Santa Barbara, CA
            <br />telephone: 1.805.682.3600
            <br />fax 1.805.682.3602
            <br />marofsb@gmail.com
          </v-card-text>
        </v-expand-transition>
        
      </div>
    </v-footer>
  </div>
</template>

<script>
import { Public } from "../api";
import { mixin as clickaway } from "vue-clickaway";
import { CMS } from "../api";

export default {
  mixins: [clickaway],
  mounted() {
  
  },
  created() {
    console.log('getting awarded')
    CMS.getAwarded(this, response => {
      console.log(response)
    })
  },
  data() {
    return {
      showInfo: "",
      passwordPrompt: false,
      password: "",
      loginFailed: false,
      isCheckingPassword: false,
      featuredPieces: [
        {
          award: "2015 Niche Award Winner",
          imageUrl: require("../assets/award_pieces/nm84_75.jpg")
        },
        {
          award: "Niche Award Finalist",
          imageUrl: require("../assets/award_pieces/975P_44.jpg")
        }
      ]
    };
  },
  computed: {
    aboutHolderPreset() {
      if (window.innerWidth > 600) return "lazy-350";
      return "fadeIn-100";
    },
    featuredPreset() {
      if (window.innerWidth > 600) return "eager-400";
      return "blurIn-0.2";
    },
    greaterThanSix() {
      if (window.innerWidth > 600) return true;
      return false;
    }
  },
  methods: {
    toggleShowInfo(type) {
      let { showInfo } = this;
      if (showInfo == type) this.showInfo = "";
      else this.showInfo = type;
    },
    enterCollections() {
      let { password, isCheckingPassword, loginFailed } = this;
      this.isCheckingPassword = true;
      Public.checkPassword(this, password, response => {
        console.log(response);
        this.isCheckingPassword = false;
        console.log(response.data)
        if (response && response.data && response.data.message === "success")
          this.$router.push({ name: "choose-collection" });
        else this.loginFailed = true;
      });
    }
  }
};
</script>
<style>
.custom.caret {
  display: none;
}
html {
  overflow: scroll;
  overflow-x: hidden;
}
::-webkit-scrollbar {
  width: 0px; /* remove scrollbar space */
  background: transparent; /* optional: just make scrollbar invisible */
}
.v-btn .v-btn__content .v-icon {
  color: black;
}
</style>
<style scoped>
.about-holder,
#featuredItemsCarousel,
.greg-info-container {
  box-shadow: 0 19px 38px rgba(0, 0, 0, 0.8), 0 15px 12px rgba(0, 0, 0, 0.82);
}
.greg-info-container {
  background: black;
  height: auto;
  padding: 2rem;
  width: 50vw;
  z-index: 99999;
}
.bottom-right-container {
  display: flex;
  flex-flow: column;
  align-items: center;
  justify-content: space-between;
  height: 100%;
}
h1 {
  font-family: "DINPro Light" !important;
}
p {
  font-family: "DINPro Regular";
}
.greg-about-image {
  background: url("../assets/headshot_greg.jpg") center center no-repeat;
  background-size: contain;
  object-fit: contain;
  height: 30rem;
  padding-left: 10%;
  width: auto;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
.about-holder {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 5%;
}
.about-holder p {
  text-align: center;
}
#awardsTitle {
  color: black;
  width: 100%;
  text-align: center;
  padding-top: 2rem;
  font-family: "DINPro Bold";
  font-size: 2rem;
}
.v-card__text {
  font-family: "DINPro Regular";
}
#aboutFooterContainer {
  padding-left: 30%;
  padding-right: 30%;
  padding-bottom: 10%;
  padding-top: 10%;
  background-color: white;
}
#featuredCarouselContainer {
  height: 45%;
  margin-top: 300px;
  box-shadow: 0 19px 38px rgba(0, 0, 0, 0.8), 0 15px 12px rgba(0, 0, 0, 0.82) !important;
}
.award-image {
  height: 18rem;
  width: 18rem;
  border-radius: 9rem;
}
.carousel-item-container {
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  background: white;
}
.award-title {
  color: black;
}
#passwordLogin {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.6);
  z-index: 99999;
  display: flex;
  align-items: center;
  justify-content: center;
}
#enterHolder {
  display: flex;
  flex-flow: row;
  justify-content: space-around;
}
#passwordInnerLogin {
  width: 20rem;
  height: 20rem;
  padding: 1rem;
  background-color: white;
  display: flex;
  flex-flow: column;
  align-items: center;
  justify-content: center;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.19), 0 6px 6px rgba(0, 0, 0, 0.23);
}
.close-icon {
  width: 100%;
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
}
.close-icon:hover {
  cursor: pointer;
}
@media only screen and (max-width: 600px) {
  #enterHolder {
    display: flex;
    align-items: center;
    flex-flow: column;
    height: auto !important;
    justify-content: space-between;
    padding-top: 2rem;
    padding-bottom: 2rem;
  }
  #enterHolder > div {
    margin: 2rem !important;
  }
  .about-holder {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 5%;
    width: 90% !important;
  }
  #featuredCarouselContainer {
    width: 90% !important;
    margin: 0 !important;
  }
  .top-neck {
    height: 100vh !important;
    display: flex;
    align-items: center;
    justify-content: center;
    background: url("../assets/neck.jpg") no-repeat center center scroll;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
    background-size: cover;
  }
  .footer-greg {
    display: flex;
    flex-flow: column;
    padding-top: 2rem !important;
    padding-bottom: 5rem !important;
  }
  .footer-greg > div {
    margin-top: 2rem;
  }
  .title-text {
    font-size: 3rem !important;
  }
}
</style>



// WEBPACK FOOTER //
// Landing.vue?3cae500c